window.PopupForm = {


    init(){


        const form =
        document.getElementById(
            "MaisaNewsletterForm"
        );


        /*
        ============================
        Loader botón
        ============================
        */


        if(form){


            form.addEventListener(
                "submit",
                ()=>{


                    const button =
                    form.querySelector(
                        "button"
                    );


                    if(!button) return;


                    button.disabled = true;


                    button.classList.add(
                        "loading"
                    );


                    button.innerHTML =
                    "Enviando...";


                }
            );


        }



        /*
        ============================
        Registro exitoso Shopify
        ============================
        */


        const urlParams =
        new URLSearchParams(
            window.location.search
        );



        if(
            urlParams.has(
                "customer_posted"
            )
        ){


            console.log(
                "Cliente registrado"
            );



            const popup =
            PopupController.popup;



            if(popup){


                popup.classList.add(
                    "active"
                );


                popup.setAttribute(
                    "aria-hidden",
                    "false"
                );


                document.body.style.overflow =
                "hidden";


            }



            const formContainer =
            document.getElementById(
                "MaisaPopupForm"
            );



            const successContainer =
            document.getElementById(
                "MaisaPopupSuccess"
            );



            if(formContainer){

                formContainer.style.display =
                "none";

            }



            if(successContainer){

                successContainer.style.display =
                "block";

            }



            PopupStorage.setSubscribed();



            window.history.replaceState(
                {},
                "",
                window.location.pathname
            );

        }


    }


};